<template>
	<div id="app">
		<div>
			<p style="text-align: center;">我的课表</p>
		</div>
		<ScheduleCalendar @onclick="handleDateClick" @onyearmonth="handleYearMonthChange" :classlist="list" :choose="day" />
		<!-- 遍历 classlist -->
		<div class="Table" v-for="(item, index) in classlist" :key="index" @click="studentinfo(item)">
			<div class="tabletime">
				<div style="font-size: 19px; font-weight: 700">
					{{ item.startTime }} ~ {{ item.endTime }}
				</div>
				<div v-if="new Date(item.courseDate).getTime() > new Date(today).getTime()" class="tabletatus1">
					<span>未上课</span>
				</div>
				<div v-else-if="new Date(item.courseDate).getTime() <= new Date(today).getTime() && item.attendNum == 0" class="tabletatus">
					<span>未签到</span>
				</div>
				<div v-else-if="new Date(item.courseDate).getTime() <= new Date(today).getTime() && item.attendNum > 0" class="tabletatus1">
					<span>已签到</span>
				</div>
			</div>
			<div class="tablename">{{ item.className }}</div>
			<div class="tableschool">
				<span>校区：</span>
				<span>{{ item.schoolRegion }}</span>
			</div>
			<div class="tableteacher">
				<span>老师：</span>
				<span>{{ item.mainTeacher }}</span>
			</div>
			<div class="tableclass">
				<span>教室：</span>
				<span>{{ item.classroomName }}</span>
			</div>
			<div class="tableline"></div>
			<div class="tablenum">
				<div>
					<span>上课人数：</span>
					<span class="tablesigned">{{ item.courseProgress }}</span>
				</div>
				<img style="width: 8px" src="../assets/right-icon.png" alt="right-icon" />
			</div>
		</div>
		<!-- 如果 classlist 为空 -->
		<div v-if="day != '' && classlist.length == 0">
			<DEmpty text="今天没有课程安排"></DEmpty>
		</div>
		<div style="height: 20px;"></div>
	</div>
	</div>
</template>

<script>
	import DEmpty from '../components/d-empty.vue'; // 引入组件
	import ScheduleCalendar from "../components/ScheduleCalendar.vue";
	import {
		basCourseMonth,
		basCourseDay
	} from '../request/api.js';
	export default {
		name: "App",
		components: {
			ScheduleCalendar,
			DEmpty
		},
		data() {
			return {
				day: '',
				classlist: [],
				list: [],
				ymday: '',
				today: '',
			}
		},
		created() {
			var courseDay = localStorage.getItem('courseDay');
			if (courseDay) {
				this.day = courseDay;
				this.ymday = this.day.substring(0, 6)
				localStorage.removeItem('courseDay');
			} else {
				this.day = this.$utils.getNowDate('ymd');
				this.ymday = this.$utils.getNowDate('ym');
			}
			this.ymday = this.$utils.getNowDate('ym');
			this.today = this.$utils.getNowDate('ymd');
			var token = localStorage.getItem("token");
			if (token) {
				this.getbasCourseMonth();
				this.getbasCourseDay();
			} else {
				this.$router.push({
					name: "Login"
				}) //路由跳转
			}
		},
		methods: {
			// 处理子组件的 onclick 事件
			handleDateClick(date) {
				console.log('用户点击的日期:', date);
				this.day = date;
				this.getbasCourseDay()
			},
			// 处理子组件的 onyearmonth 事件
			handleYearMonthChange(date) {
				console.log('当前年月:', date);
				this.ymday = date;
				this.day = '';
				this.classlist = [];
				this.getbasCourseMonth()
			},
			getbasCourseDay() {
				var that = this;
				that.classlist = []
				basCourseDay('date=' + that.day).then((res) => {
					if (res.data.code == 0) {
						this.classlist = res.data.data;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning',
						})
					}
				});
			},
			getbasCourseMonth() {
				var time = this.ymday.split("-")
				var year = time[0]
				var month = time[1]
				basCourseMonth('year=' + year + '&month=' + month).then((res) => {
					if (res.data.code == 0) {
						this.list = res.data.data;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning',
						})
					}
				});
			},
			studentinfo(item) {
				localStorage.removeItem('courseDay');
				localStorage.setItem('courseDay', this.day);
				var data = item.courseId;
				this.$router.push({
					name: 'scheduledetails',
					params: {
						id: data
					},
				});
			},
		},
	}
</script>


<style>
	.Table {
		width: 96%;
		margin: 10px auto;
		border-radius: 6px;
		background: #FFFFFF;
		box-shadow: 0px 10px 14px 10px rgb(139 139 139 / 20%);
	}

	.tabletime {
		display: flex;
		justify-content: space-between;
		padding: 10px;
	}

	.tablename {
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.tableschool {
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.tableteacher {
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.tableclass {
		padding: 0 10px;
		margin-bottom: 10px;
	}

	.tableline {
		width: 98%;
		margin: 0 auto;
		border-bottom: 1px solid;
	}

	.tablenum {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.tabletatus {
		color: #ff0000;
	}

	.tabletatus1 {
		color: #80ba21;
	}

	.tablesigned {
		color: #02a7f0;
	}
</style>